import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import Swal from "sweetalert2";
import { getAllJobs, deleteJob } from "../redux/slices/jobSlice";
import { Link } from "react-router-dom";

const AllJobs = () => {
    const dispatch = useDispatch();
    const { jobs, loading } = useSelector((state) => state.jobs);

    /* ================= FETCH JOBS ================= */
    useEffect(() => {
        dispatch(getAllJobs({ page: 1 }));
    }, [dispatch]);

    /* ================= DELETE HANDLER ================= */
    const handleDeleteJob = (jobId) => {
        Swal.fire({
            title: "Are you sure?",
            text: "This job will be permanently deleted",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            confirmButtonText: "Yes, delete",
        }).then(async (result) => {
            if (result.isConfirmed) {
                const res = await dispatch(deleteJob(jobId));

                if (deleteJob.fulfilled.match(res)) {
                    Swal.fire({
                        icon: "success",
                        title: "Deleted!",
                        text: "Job deleted successfully",
                        timer: 1500,
                        showConfirmButton: false,
                    });
                }
            }
        });
    };

    /* ================= UI ================= */
    return (
        <div className="container py-4">
            <div className="card shadow-sm">
                <div className="card-header bg-white">
                    <h5 className="mb-0">All Jobs</h5>
                </div>

                <div className="card-body p-0">
                    {loading ? (
                        <div className="text-center py-5">
                            <div className="spinner-border text-primary" />
                        </div>
                    ) : jobs?.length === 0 ? (
                        <p className="text-center py-4 text-muted">
                            No jobs available
                        </p>
                    ) : (
                        <table className="table table-hover mb-0">
                            <thead className="table-light">
                                <tr>
                                    <th>Title (Requirement) </th>
                                    <th>Description</th>
                                    <th>Posted By</th>
                                    <th>Posted</th>
                                    <th width="120">Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {jobs.map((job) => (
                                    <tr key={job._id}>
                                        <td className="fw-semibold">{job.title}</td>
                                        <td className="text-muted">
                                            {job.description?.slice(0, 60)}...
                                        </td>
                                        <td>{job.user?.name || "User"}</td>
                                        <td className="text-muted">
                                            {moment(job.createdAt).fromNow()}
                                        </td>
                                        <td>
                                            <Link
                                                className="btn btn-sm btn-primary me-2"
                                                to={`/applicant-list/${job._id}`}
                                            >
                                                Applicant List
                                            </Link>
                                            <button
                                                className="btn btn-sm btn-danger"
                                                onClick={() => handleDeleteJob(job._id)}
                                            >
                                                Delete
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    )}
                </div>
            </div>
        </div>
    );
};

export default AllJobs;
